import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import SWDLayout from "layouts/SWD.js";
import AuthLayout from "layouts/Auth";
// Chakra imports
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
// Custom Chakra theme
import theme from "theme/theme.js";

ReactDOM.render(
  <ChakraProvider theme={theme} resetCss={false} position="relative">
    <ColorModeScript initialColorMode="dark" />
    <HashRouter>
      <Switch>
        <Route path={`/auth`} component={AuthLayout} />
        <Route path={`/swd`} component={SWDLayout} />
        <Redirect from={`/`} to="/swd/homepage" />
      </Switch>
    </HashRouter>
  </ChakraProvider>,
  document.getElementById("root"),
  () => {
    const spinner = document.getElementById('spinner');

    if (spinner && !spinner.hasAttribute('hidden')) {
      spinner.setAttribute('hidden', 'true');
    }
  }
);